const originalConsoleMethod = (method)=>{
    while(method?.__rrweb_original__)method = method.__rrweb_original__;
    return method;
};
export { originalConsoleMethod };
